import { Toro } from '../common/enumerations';
import RunningStatus = Toro.RunningStatus;

export class ActiveStationInfo
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
            this.RunningStationStatus = json['RunningStationStatus'] || RunningStatus.Unknown;

        }
    }
    RunningStationStatus: RunningStatus;
    RunningStationNumber: number;
    RunningStationName: string;
    RunningStationRemainingSeconds: number;
    TotalRuntime: number;
    IsForced = false;
}
